import { RequestDetailModel, ResponseAnnotationModel, ResponseMessageDetailModel, ResponseMessageItemModel, ResponseRequestDetailModel, ResponseRequestItemModel } from './requestsModel'
import { directionMessage, getInfoForCategoryKey, getInfoForSubcategoryId } from '../../enums/makeRequestEnum'
import { IntlShape } from 'react-intl'
import DemandesTechniqueEnum from '../../enums/demandesTechniqueEnum'

export const convertRequestList = (list: ResponseRequestItemModel[]) =>
	list.map((item: ResponseRequestItemModel) => convertRequestItem(item))
		.sort((resp1, resp2) => {
			// Tri par date de dernier message
			const resp1Date = resp1.messages.length ? resp1.messages[resp1.messages.length - 1].modifiedOn : resp1.modifiedOn
			const resp2Date = resp2.messages.length ? resp2.messages[resp2.messages.length - 1].modifiedOn : resp2.modifiedOn

			return resp2Date.getTime() - resp1Date.getTime()
		})

const convertRequestItem = (item: ResponseRequestItemModel) => ({
	id: item.incidentid,
	category: item.eft_categorie_demande_ec ? `private_${DemandesTechniqueEnum[item.eft_categorie_demande_ec]}` : item._eft_catgoriedelademande1_value,
	actif: item.statecode === 0,
	cloture: item.statecode === 1,
	annule: item.statecode === 2,
	modifiedOn: new Date(item.modifiedon),
	messages: item.eft_incident_eft_echange_Demande.map((message: ResponseMessageItemModel) => ({
		id: message.eft_echangeid,
		message: message._eft_demande_value,
		pj: message.eft_piecesjointes,
		modifiedOn: new Date(message.modifiedon)
	})),
	bail_id: item._eft_bailliid_value,
	jour1 : item.eft_creneau1edlsjour,
	jour2 : item.eft_creneau2edlsjour,
	jour3 : item.eft_creneau3edlsjour,
	heure1 : item.eft_creneau_1_heure,
	heure2 : item.eft_creneau_2_heure,
	heure3 : item.eft_creneau_3_heure,
	dateDepartSouhaitee : item.eft_datededepartsouhaitee
})

export const convertRequestDetail = (item: ResponseRequestDetailModel) => ({
	id: item.incidentid,
	category: item._eft_catgoriedelademande1_value,
	cloture: item.statecode === 1,
	annule: item.statecode === 2,
	modifiedOn: new Date(item.modifiedon),
	messages: item.eft_incident_eft_echange_Demande.map((message: ResponseMessageDetailModel) => ({
		id: message.eft_echangeid,
		message: message.eft_message,
		modifiedOn: new Date(message.modifiedon),
		sentByMe: `${message.eft_direction}` === directionMessage.entrant,
		annotation: message.eft_echange_Annotations.map((annotation: ResponseAnnotationModel) => ({
			id: annotation.annotationid,
			echange_id: item.incidentid,
			filename: annotation.filename
		}))
	})).sort((mess1, mess2) => mess1.modifiedOn.getTime() - mess2.modifiedOn.getTime()),
	creneau1_jour: item.eft_creneau_1_jour,
	creneau1_timeslot: item.eft_creneau_1_matin_ou_apres_midi,
	creneau2_jour: item.eft_creneau_2_jour,
	creneau2_timeslot: item.eft_creneau_2_matin_ou_apres_midi,
	creneau3_jour: item.eft_creneau_3_jour,
	creneau3_timeslot: item.eft_creneau_3_matin_ou_apres_midi,
	clefalaloge : item.eft_clefalaloge
} as RequestDetailModel)

const TECHNICAL_KEY = 'technical'
const PRIVATE_KEY = 'private'

/**
 * Fonction qui retourne la catégorie d'une requête
 * @param ReqCategory
 * @param intl
 */
export const getRequestCategory = (ReqCategory: string | null, intl: IntlShape) => {
	// Gestion du display de la catégorie
	let category = undefined
	let isTechnical = false
	let isPrivate = false
	if (ReqCategory) {
		const subCategoryInfo = getInfoForSubcategoryId(ReqCategory)
		if (subCategoryInfo.parentKey && subCategoryInfo.valueKey) {
			isPrivate = subCategoryInfo.parentKey === PRIVATE_KEY
			category = {
				step3: intl.formatMessage(
					{
						id: `requests.makeRequest.step3.${subCategoryInfo.valueKey}`,
						defaultMessage: subCategoryInfo.valueKey,
						description: 'Sous-catégorie'
					}
				),
				step2: intl.formatMessage(
					{
						id: `requests.makeRequest.step2.${subCategoryInfo.parentKey}`,
						defaultMessage: subCategoryInfo.parentKey,
						description: 'Catégorie'
					}
				)
			}
			const categoryInfo = getInfoForCategoryKey(subCategoryInfo.parentKey)
			if (categoryInfo.parentKey) {
				isTechnical = categoryInfo.parentKey === TECHNICAL_KEY
				category = {
					...category,
					step1: intl.formatMessage(
						{
							id: `requests.makeRequest.step1.${categoryInfo.parentKey}`,
							defaultMessage: categoryInfo.parentKey,
							description: 'Type'
						}
					)
				}
			}
		}
	}
	return {
		isTechnical, isPrivate, labelCategory: category ? `${category.step1} - ${category.step2}` : intl.formatMessage(
			{
				id: 'requests.otherCategory',
				defaultMessage: 'Autres',
				description: 'Type'
			}
		),
		subCategory: category ? category.step3 : intl.formatMessage(
			{
				id: 'requests.otherCategory',
				defaultMessage: 'Autres',
				description: 'Type'
			}
		)
	}
}
